module.exports = __webpack_public_path__ + "img/coffee-bean.5ec799e0.svg";